import { cardTypesConstants } from "../constants/action.constants";

const initialState = {
  submitting: false,
  submitted: false,
  request: null,
  response: null,
  error: null
};

export const addCardType = (state = initialState, action) => {
  switch (action.type) {
    case cardTypesConstants.ADD_CARDTYPE_REQUEST:
      return {
        ...state,
        submitting: true,
        submitted: false,
        request: action.requestBody,
        response: null,
        error: null
      };
    case cardTypesConstants.ADD_CARDTYPE_SUCCESS:
      return {
        ...state,
        submitting: false,
        submitted: true,
        response: action.response,
        error: null
      };
    case cardTypesConstants.ADD_CARDTYPE_FAILURE:
      return {
        ...state,
        submitting: false,
        submitted: false,
        response: null,
        error: action.error
      };
    case cardTypesConstants.ADD_CARDTYPE_RESET:
      return {
        ...state,
        ...initialState
      };
    default:
      return state;
  }
};
